(function(module) {
    'use strict';

    function SchedulesCtrl($state, Schedule, Store, $mdDialog, App, Includes, AppStylesInPlaylist, Display, Group) {

        this.getApps = () => {
            return App
                .find({ filter: Includes.apps })
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.apps = Store.setMultiModelData('apps', response);
                    return response;

                });
        };

        this.setDefault = () => {
            this.schedules = null;
            this.apps = null;
            this.appsWithStyles = null;

            this.loading = true;
            this.selectedCount = 0;
        };

        this.getData = () => {
            return Schedule
                .find()
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.schedules = Store.setMultiModelData('schedules', response);
                })
                .then(() => {
                    return this.getApps();
                })
                .then((apps) => {
                    // get styles and name for the app in the schedule
                    this.schedules.forEach((schedule) => {
                        this.appsWithStylesInSchedule = AppStylesInPlaylist.getAppStylesInPlaylist(schedule.apps, apps);
                        schedule.appsWithStyles = [];
                        schedule.appsWithStyles = this.appsWithStylesInSchedule;

                    });
                });
        };

        this.$onInit = () => {
            this.selectAllCheckbox = false;
            this.orderBy = 'name';

            this.setDefault();
            this.getData();
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onDestroy = () => {

        };

        this.selectAll = () => {
            this.filteredItems.forEach((schedule) => {
                schedule.selected = this.selectAllCheckbox;
            });
            this.updateSelectedCount();
        };

        this.updateSelectedCount = () => {
            this.selectedCount = _.chain(this.schedules).filter((schedule) => schedule.selected).size().value();
        };

        this.select = () => {
            this.updateSelectedCount();
        };

        this.findDisplaysUsingScheduleId = (scheduleIds) => {
            return Display
                .find({
                    filter: {
                        where: { scheduleId: { inq: scheduleIds } },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.findGroupsUsingScheduleId = (scheduleIds) => {
            return Group
                .find({
                    filter: {
                        where: { scheduleId: { inq: scheduleIds } },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.openDialog = (modalTitle, modalConfirmationText, modalCancelText, modalConfirmText, confirmActionFunc, itemCount1, itemCount2, ids) => {
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    itemCount1: itemCount1,
                    itemCount2: itemCount2,

                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();

                        confirmActionFunc(ids);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.delete = () => {
            const ids = _.chain(this.schedules)
                .filter({ selected: true })
                .map((item) => item.id)
                .value();

            Promise.all([
                this.findDisplaysUsingScheduleId(ids),
                this.findGroupsUsingScheduleId(ids),
            ])
                .then(([displaysUsingSchedule, groupsUsingSchedule]) => {
                    let displaysUsingScheduleCount = displaysUsingSchedule && displaysUsingSchedule.length;
                    let groupsUsingScheduleCount = groupsUsingSchedule && groupsUsingSchedule.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;

                    //schedule not being used by both displays and groups : remove schedule

                    if (displaysUsingScheduleCount <= 0 && groupsUsingScheduleCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove selected schedules?';
                        modalConfirmText = 'Yes, remove';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (ids) => {
                            return Schedule.destroyAll({
                                where: { id: { inq: ids } },
                            })
                                .$promise
                                .then(() => {
                                    _.remove(this.schedules, (schedule) => _.indexOf(ids, schedule.id) >= 0);
                                    this.selectAllCheckbox = false;
                                    if (this.schedules.length === 0) {
                                        this.selectedCount = 0;
                                    }
                                })
                                .catch((error) => {
                                    console.error('error', error);
                                });
                        };
                        //display is using schedule but the group isnt
                    } else {
                        modalTitle = 'You can\'t delete selected schedule/s as being used by :';

                        itemCount1 = displaysUsingScheduleCount > 0 ? `${displaysUsingScheduleCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingScheduleCount > 0 ? `${groupsUsingScheduleCount + ' of your groups'}` : null;

                        modalConfirmationText = 'Please make sure the schedules are not being used before deleting.';
                        modalCancelText = 'Ok, I understand';
                    }

                    this.openDialog(modalTitle, modalConfirmationText, modalCancelText, modalConfirmText, confirmActionFunc, itemCount1, itemCount2, ids);

                });
        };
    }

    module
        .config(($stateProvider, $translatePartialLoaderProvider, envServiceProvider) => {

            const FEATURES = envServiceProvider.read('features');
            const SCHEDULES = _.get(FEATURES, 'schedules', false);

            $stateProvider.state('root.schedules', {
                url: '/schedules',
                data: {
                    pageTitle: 'SCHEDULES.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        template: '<schedules-component />',
                    },
                },

                bodyClass: 'page--schedules',
                resolve: {
                    show: function($state) {
                        if (FEATURES && !SCHEDULES) {
                            return $state.go('root');
                        }
                    },
                },
            });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/schedules');

        })
        .component('schedulesComponent', {
            templateUrl: '/js/schedules/schedules.html',
            controller: SchedulesCtrl,
        });

})(angular.module('rocket.components'));
